import React from 'react';
import GridProductLookup from './index';
import { LookupRow } from './types';

export interface CorrectiveTypeLookupHandlers {
  params?: string;
  PegarValorGrid: (row: LookupRow) => void;
  Iconeadd: () => void;
  Iconeditar: (row: LookupRow) => void;
  iconeExcluir?: (row: LookupRow) => void;
}

export function renderCorrectiveTypeLookupGrid(
  handlers: CorrectiveTypeLookupHandlers,
): React.ReactElement {
  return (
    <GridProductLookup
      endPoint="correctivetype/buscarcorrectivetype"
      params={handlers.params ?? ''}
      listTitle="Tipos Corretiva"
      listSubtitle="Selecione um tipo ou cadastre um novo."
      newButtonLabel="Novo tipo"
      searchPlaceholder="Pesquisar tipos corretiva..."
      PegarValorGrid={handlers.PegarValorGrid}
      Iconeadd={handlers.Iconeadd}
      Iconeditar={handlers.Iconeditar}
      onDelete={handlers.iconeExcluir}
    />
  );
}
